import * as type from "../types";

export function login(payload) {
  console.log("login payload", payload);
  return {
    type: type.USER_LOGIN,
    payload: payload,
  };
}

export function getUserDetails(payload){
  return {
    type: type.GET_USER_DETAILS,
    payload: payload,
  };
}

export function logOut() {
  return {
    type: type.USER_LOGOUT,
  };
}